import { arrow1, arrow2, arrowCap } from '../lace/arrow'
import { topSidePartOfWeb } from './parts/sideParts'

export const wp5Web = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  // ウェブ本体
  ctx.beginPath()
  ctx.moveTo(300, 376) // 左下
  ctx.quadraticCurveTo(339, 334, 373, 252) // 右下
  ctx.quadraticCurveTo(384, 159, 359, 92) // 右上
  ctx.quadraticCurveTo(269, 153, 210, 260) // 左上
  ctx.quadraticCurveTo(300, 376, 300, 376) // 左下
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // ウェブ先端
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)

  // レース模様_1
  ctx.beginPath()
  ctx.moveTo(317, 233) // 左上
  ctx.quadraticCurveTo(368, 255, 368, 255) // 右下
  ctx.stroke()
  ctx.closePath()
  // レース模様_2
  ctx.beginPath()
  ctx.moveTo(243, 274) // 左上
  ctx.quadraticCurveTo(288, 288, 288, 288) // 右下
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.lineWidth = 1.2
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])

  // W模様＿下段のステッチ
  ctx.moveTo(331, 124) // 上
  ctx.quadraticCurveTo(358, 221, 358, 221)
  ctx.quadraticCurveTo(304, 222, 304, 222)
  ctx.quadraticCurveTo(333, 323, 333, 323)
  ctx.quadraticCurveTo(288, 349, 288, 349)

  //  W模様＿上段のステッチ
  ctx.moveTo(298, 155)
  ctx.quadraticCurveTo(321, 204, 321, 204)
  ctx.quadraticCurveTo(272, 202, 272, 202)
  ctx.quadraticCurveTo(301, 298, 301, 298)
  ctx.quadraticCurveTo(274, 323, 274, 323)

  // レース模様_1
  ctx.moveTo(368, 251) // 右下_上
  ctx.quadraticCurveTo(315, 228, 315, 228) // 左上_上
  ctx.quadraticCurveTo(310, 235, 310, 235) // 左上_下
  ctx.quadraticCurveTo(367, 259, 367, 259) // 右下_下

  // レース模様_2
  ctx.moveTo(240, 269) // 左上_上
  ctx.quadraticCurveTo(293, 285, 293, 285) // 右下_上
  ctx.quadraticCurveTo(291, 294, 291, 294) // 右下_下
  ctx.quadraticCurveTo(244, 280, 244, 280) // 右下_上

  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()

  // レースここから
  arrowCap(ctx, laceColor, -4, -2)
  arrow1(ctx, laceColor, 0, 0)
  arrow1(ctx, laceColor, 10, 5)
  arrow1(ctx, laceColor, 20, 10)
  arrow1(ctx, laceColor, 30, 15)

  arrow2(ctx, laceColor, 0, 0)
  arrow2(ctx, laceColor, -14, -5)
  arrow2(ctx, laceColor, -28, -10)
}
